<div class="isf-detail-desktop">
  <div class="isf-detail-row">
    <div class="isf-detail-col-display-part">
      <div class="isf-detail-col isf-detail-col-name">
        <a class="btn btn-link" [routerLink]="['/isf', isf.referenceNumber]">{{ isf.referenceNumber }}</a>
        <span class="isf-detail-transaction-number" *ngIf="!!isf.transactionNumber">{{ isf.transactionNumber }}</span>
      </div>

      <div class="isf-detail-col isf-detail-col-cbp">
        <span>{{ isf.receivedByCbpDate | customDateByUtc }}</span>
      </div>

      <div class="isf-detail-col isf-detail-col-bl" [title]="billOfLadingInfo">
        <span>{{ billOfLadingInfo }}</span>
      </div>

      <div class="isf-detail-col isf-detail-col-status">
        <isf-status [state]="isf.state" [paymentState]="isf.paymentState" [isf]="isf"></isf-status>
      </div>
    </div>

    <div class="isf-detail-col isf-detail-col-actions">
      <ng-container [ngTemplateOutlet]="actionIcons"></ng-container>

      <isf-actions
        [isf]="isf"
        [viewIsf]="false"
        [showPrint]="false"
        [showViewIsf]="true"
        [showInList]="true"
        (update)="onUpdate($event)"
      ></isf-actions>
    </div>
  </div>
</div>

<div class="isf-detail isf-detail-mobile">
  <div class="container">
    <div class="row">
      <div class="col-12 isf-detail-header" [routerLink]="['/isf', isf.referenceNumber]">
        <div class="row">
          <div class="col-12">
            <div class="w-100 d-flex justify-content-start align-items-center mb-3 isf-detail-name">
              <a class="btn btn-link mr-3">{{ isf.referenceNumber }}</a>
              <span class="isf-detail-transaction-number" *ngIf="!!isf.transactionNumber">{{ isf.transactionNumber }}</span>
            </div>
          </div>

          <div class="col-12 d-flex">
            <isf-status [state]="isf.state" [paymentState]="isf.paymentState" [isf]="isf"></isf-status>
          </div>
        </div>
      </div>

      <div class="col-12 isf-detail-body" [routerLink]="['/isf', isf.referenceNumber]">
        <div class="row" *ngIf="!!isf.receivedByCbpDate">
          <div class="col-6">
            <span class="isf-detail-body-header">{{ "STATUS.SECOND_TEXT.RECEIVED_BY_CBP" | translate }}</span>
          </div>
          <div class="col-6">
            <span>{{ isf.receivedByCbpDate | customDateByUtc }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-4">
            <span class="isf-detail-body-header">{{ "LABELS.BILL_OF_LADING" | translate }}</span>
          </div>
          <div class="col-8" [title]="billOfLadingInfo">
            <span>{{ billOfLadingInfo }}</span>
            <strong *ngIf="!isValidShipment" class="btn-link">{{ "LABELS.REQUIRED" | translate }}</strong>
          </div>
        </div>
      </div>

      <div class="col-12 isf-detail-footer">
        <div class="d-flex justify-content-between align-items-center">
          <span>{{ "LABELS.ACTIONS" | translate }}</span>

          <ng-container [ngTemplateOutlet]="actionIcons"></ng-container>

          <isf-actions
            [isf]="isf"
            [viewIsf]="false"
            [showPrint]="false"
            [showViewIsf]="true"
            [showInList]="true"
            (update)="onUpdate($event)"
          ></isf-actions>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #actionIcons>
  <ng-container *ngIf="isShowInsuranceIndicator">
    <app-marine-insurance-indicator
      [entityReferenceNumber]="isf.referenceNumber"
      entityRedirectPath="/isf"
      [companyPlacement]="enumCompanyPlacement.ISF"
      [entityStatus]="isf?.insuranceStatus"
    ></app-marine-insurance-indicator>
  </ng-container>

  <img
    src="/assets/icons/icon_note_gray.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'LABELS.INTERNAL_NOTES_ADD' | translate"
    *ngIf="!isf.internalReferenceNumber && !isf.internalNotes"
    (click)="openInternalNotes()"
  />
  <img
    src="/assets/icons/icon_note_green.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'LABELS.INTERNAL_NOTES_EDIT' | translate"
    *ngIf="!!isf.internalReferenceNumber || !!isf.internalNotes"
    (click)="openInternalNotes()"
  />

  <img
    src="/assets/icons/icon_es_gray.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'BUTTON.CREATE_ENTRY' | translate"
    *ngIf="!isf.entrySummaryReferenceNumber"
    (click)="createEntry()"
  />
  <img
    src="/assets/icons/icon_es_green.svg"
    nz-popover
    nzPopoverOverlayClassName="tooltip-sm"
    nzPopoverTrigger="hover"
    [nzPopoverContent]="'LABELS.VIEW_CONNECTED_ENTRY' | translate"
    *ngIf="!!isf.entrySummaryReferenceNumber"
    (click)="viewEntry()"
  />
</ng-template>
